import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Marketing", -1)

import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentSlider',
  setup(__props) {

const slides = [
  {
    // You can also provide a URL for the image.
    image: "https://www.w3schools.com/w3images/sound.jpg",
  },
  {
    // You can also provide a URL for the image.
    image:
      "https://gezginsitesi.com/wp-content/uploads/2019/02/eymir-kapak.jpg",
  },
  {
    image:
      "https://static.wixstatic.com/media/8af23d_0fd9fa14c2034fc6a5ca1fb1a97fc317~mv2.jpg/v1/fill/w_726,h_312,al_c,lg_1,q_80,enc_auto/8af23d_0fd9fa14c2034fc6a5ca1fb1a97fc317~mv2.jpg",
  },
  {
    image: "https://gaiadergi.com/wp-content/uploads/2015/08/maldivler3.jpg",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(VueperSlides), {
      fade: "",
      touchable: true
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(slides, (slide, i) => {
          return _createVNode(_unref(VueperSlide), {
            key: i,
            image: slide.image
          }, null, 8, ["image"])
        }), 64))
      ]),
      _: 1
    })
  ]))
}
}

})